module.exports = __webpack_public_path__ + "media/images/icons/ic-name-d442f5b580aac415320ceaddb595e7a2.svg";